import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ImportUnitGQL, ImportUnitOptionsGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";
import { GraphQLError } from "graphql";

export interface DialogData {
  project_id: string
}

@Component({
  selector: "upload-unit-action-dialog",
  templateUrl: "upload-unit-action.html",
})
export class UploadUnitActionDialog {
  projectID: string;
  displayMethods: boolean = false;
  allowOverwrite: boolean = false;
  allowAppend: boolean = false;
  selectedMethod: string;
  fileName: string;
  file: any;
  isSubProduct: boolean;
  
  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private importUnitGQL: ImportUnitGQL,
    private importUnitOptionsGQL: ImportUnitOptionsGQL,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<UploadUnitActionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.projectID = this.data.project_id;
    this.getImportOptions();
  }

  private getImportOptions() {
    this.importUnitOptionsGQL.fetch({ projectId: this.projectID, isSubProduct: this.isSubProduct })
      .subscribe(result => {
        if (result?.errors) {
          this.snackBarService.showQueryError(result.errors);
        }
        let data = result.data.ImportUnitOptions;
        this.displayMethods = data.displayImportMethods;
        this.allowOverwrite = data.overwrite;
        this.allowAppend = data.append;
      });
  }

  fileChangeEvent(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.file = fileInput.target.files[0];
      this.fileName = this.file.name;
    }
    this.fileInput.nativeElement.value = null;
  }

  uploadExcel() {
    if (this.displayMethods && !this.selectedMethod) {
      this.snackBarService.show("Please select an upload method.");
      return;
    }
    if (!this.fileName) {
      this.snackBarService.show("Please upload an excel template.");
      return;
    }

    this.importUnitGQL
      .mutate({
        projectId: this.projectID,
        excel: this.file,
        method: this.displayMethods ? this.selectedMethod : "O",
        isSubProduct: this.isSubProduct
      }, {
        context: {
          useMultipart: true,
        },
      }).subscribe(
        (result) => {
          let data = result.data.ImportUnit;
          if (data) {
            this.snackBarService.show(data.message);
            if (data.file && data.message) {
              let file = {
                file: data.file,
                file_name: data.file_name
              }
              this.decodeExcel(file)
            } else {
              this.dialogRef.close(true);
            }
          }
        },
        (err: GraphQLError) => {
          this.snackBarService.showMutationError(err);
        }
      );
  }

  decodeExcel(data) {
    let prefix = 'data:application/vnd.ms-excel;base64,'
    let a = document.createElement('a')
    let content = prefix + data.file;
    a.setAttribute('href', content)
    a.setAttribute('download', data.file_name);
    a.setAttribute('target', '_blank');
    a.setAttribute('id', "download");
    if (document.getElementById('download')) {
      document.body.removeChild(document.getElementById('downLoad'));
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
